<div class="exception-body">
    <div class="exception-container flex align-items-center justify-content-center flex-column bg-auto md:bg-contain bg-no-repeat">
        <div class="exception-panel text-center flex align-items-center justify-content-center flex-column">
            <i class="pi pi-exclamation-circle processing mb-0"></i>
            <h3 class="title text-primary-600">Organization subscription inactive</h3>
            <p class="message">
                Your organization's subscription is inactive. Please contact your organization owner or administrator to restore access.
            </p>
            <a pButton label="Organization billing" routerLink="/org/settings/billing" class="mb-2"></a>
            <a pButton label="My profile" routerLink="/settings/profile" class="mb-2 p-button-text"></a>
            <button type="button" pButton label="Sign out" (click)="onSignOut()"></button>
        </div>
    </div>
</div>
